import { apiClient } from './apiClient';

const getUsers = async () => {
  return await apiClient.get('/dashboard/users');
};

const createUser = async (payload) => {
  return await apiClient.post('/dashboard/users', payload);
};

const updateUser = async (id, payload) => {
  return await apiClient.patch(`/dashboard/users/${id}`, payload);
};

const deleteUser = async (id) => {
  return await apiClient.delete_req(`/dashboard/users/${id}`);
};

export const userApi = {
  getUsers,
  createUser,
  updateUser,
  deleteUser
};
